import { Box, Menu } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { DRAWER_WIDTH_CLOSED, DRAWER_WIDTH_CLOSED_XS, DRAWER_WIDTH_OPEN } from 'styles/theme';

import {
  Button,
  Typography
} from '@mui/material';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  container: {
    height: 'auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    whiteSpace: 'nowrap',
    width: `calc(100% - ${DRAWER_WIDTH_CLOSED_XS}px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${DRAWER_WIDTH_CLOSED}px)`
    }
  },
  drawerOpen: {
    width: `calc(100% - ${DRAWER_WIDTH_OPEN})`
  },
  headerFixed: {
    zIndex: 4
  },
  tabFixed: {
    paddingTop: '100px',
    zIndex: 3
  },
  previewTabFixed: {
    paddingTop: '10px',
    zIndex: 3
  },
  estimateHeaderFixed: {
    paddingTop: '150px',
    zIndex: 2
  },
  previewEstimateHeaderFixed: {
    paddingTop: '15px',
    zIndex: 3
  }
});

const StatusMenu = props => {
  const { statusHeader, currentStatus, statusList, isHomesale = false } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const normalizedStatusList = Array.isArray(statusList) ? statusList : [];
  const getStatusTitle = value => {
    if (typeof value === 'string') return value;
    if (value && typeof value === 'object') return value.title || 'Initiated';
    return 'Initiated';
  };
  const status = getStatusTitle(currentStatus || (normalizedStatusList.length > 0 ? normalizedStatusList[0] : 'Initiated'));
  let activeStatuses = [];
  if(isHomesale) {
    activeStatuses = normalizedStatusList
    .filter(s => {
      if (!s.isActive) return false;
      const num = Number(s.additionalField);
      return !isNaN(num) && s.additionalField !== null && s.additionalField !== '';
    })
    .sort((a, b) => Number(a.additionalField) - Number(b.additionalField));
  const inactiveCurrentStatus = normalizedStatusList.find(s => s.title === currentStatus);
  if (inactiveCurrentStatus && !activeStatuses.some(s => s.id === inactiveCurrentStatus.id)) {
    activeStatuses.push(inactiveCurrentStatus);
  }
  } else {
      activeStatuses = normalizedStatusList
    .filter(s => {
      if (!s.isActive) return false;
      if(s.additionalField) {
        const num = Number(s.additionalField);
        return !isNaN(num) && s.additionalField !== null && s.additionalField !== '';
      }
      else {
        return true;
      }
    })
    .sort((a, b) => Number(a.additionalField) - Number(b.additionalField));
  }
  
    let fullStatusList = activeStatuses.map((statusItem, index) => {
        let numDays = 0;
        const oneDayInMs = 1000 * 60 * 60 * 24;
        const startDate = statusItem.date ? new Date(statusItem.date) : null;
        const nextStatusDate = activeStatuses[index + 1]?.date;
        const endDate = statusItem.title === currentStatus
          ? new Date()
          : nextStatusDate ? new Date(nextStatusDate) : null;

        if (startDate && endDate) {
          const diffInMs = endDate.getTime() - startDate.getTime();
          if (Number.isFinite(diffInMs) && diffInMs >= 0) {
            numDays = Math.ceil(diffInMs / oneDayInMs);
          }
        }

        return {
            ...statusItem,
            numDays: numDays
        };

    });

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} sx={{
                backgroundColor: status === 'Canceled'
                    ? '#e0e0e0'
                    : status === 'On Hold'
                    ? '#ffcc55'
                    : '#b2d8bd',
                textTransform: 'none',
                borderRadius: '4px',
                  padding: '3px 4px',
                  display: 'inline-block',
                  marginRight: '20px'}}>
                <Box sx={{ display: 'flex', flexDirection: 'row', marginBottom: '4px', marginRight: '20px' }}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                    {statusHeader}
                    </Typography>
                    <FontAwesomeIcon icon={['fas', 'chevron-down']} size="xs" color="#43423a" style={{ marginLeft: '6px', marginTop: '6px' }} />
                </Box>
                <Box sx={{  marginBottom: '4px', marginRight: '20px' }}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                    {status}
                    </Typography>
                </Box>
            </Button>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 700, fontSize: '1rem', marginRight: '80px' }}>
                        Status
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 700, fontSize: '1rem', marginRight: '40px' }}>
                        Began
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 700, fontSize: '1rem', marginRight: '20px' }}>
                        Num Days
                    </Typography>                    
                </Box>
                {fullStatusList.map((statusItem, index) => (
                  statusItem && statusItem.id !== '00000000-0000-0000-0000-000000000000' ? (
                    <Box key={statusItem.id || index} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px', backgroundColor: statusItem.title === 'On Hold' ? '#ffcc55' : statusItem.title === 'Canceled' ? '#e0e0e0' : statusItem.title === status ? '#b2d8bd' : 'transparent' }}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', marginRight: '20px' }}>
                        {statusItem?.title}
                      </Typography>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', marginRight: '20px' }}>
                        {statusItem?.date ? `(${new Date(statusItem.date).toLocaleDateString()})` : '-'}
                      </Typography>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', marginRight: '20px' }}>
                        {statusItem?.numDays}
                      </Typography>
                    </Box>
                  ) : null
                ))}
            </Menu>
        </div>
    );
};

StatusMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  statusList: PropTypes.array.isRequired
};

const mapStateToProps = state => ({
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(StatusMenu);